import type { FederatedPersona } from './types.js';

export const DEFAULT_PERSONA_STORAGE_KEYS = ['triedge_persona', 'ystnj_persona'] as const;

export const isFederatedPersona = (value: string): value is FederatedPersona =>
  ['staff', 'administrator', 'parent'].includes(value);

export const readPersistedPersona = (
  keys: ReadonlyArray<string> = DEFAULT_PERSONA_STORAGE_KEYS
): FederatedPersona | '' => {
  if (typeof window === 'undefined') {
    return '';
  }
  for (const key of keys) {
    const value = window.localStorage.getItem(key);
    if (value && isFederatedPersona(value)) {
      return value;
    }
  }
  return '';
};

export const writePersistedPersona = (
  persona: FederatedPersona | '',
  keys: ReadonlyArray<string> = DEFAULT_PERSONA_STORAGE_KEYS
): void => {
  if (typeof window === 'undefined') {
    return;
  }
  for (const key of keys) {
    if (persona) {
      window.localStorage.setItem(key, persona);
    } else {
      window.localStorage.removeItem(key);
    }
  }
};
